<script>
import { mapActions, mapState } from 'vuex';
import axios from 'axios';
import { sendEmailInvite, getSignNowStatusApi, downloadPdf, resendSignNowInviteApi } from '@/app/api';
import checkMark from "@/assets/img/icons/check-mark.svg";

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

export default {
	props: {
		application: {
			type: Object,
			default: null
		},
		getApplication: {
			type: Function,
			default: () => {}
		},
		nextStep: {
			type: Boolean,
			default: false
		},
		previousStep: {
			type: Boolean,
			default: false
		},
		saveStep: {
			type: Object,
			default: {
				saving: false
			}
		},
		setNextDisabled: {
			type: Function,
			default: () => {}
		},
		type: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			//icons
			checkMark: checkMark,
			//variables
			docusealUrl: process.env.VUE_APP_DOCUSEAL_URL,
			isDisableButtons: false,
			isAllSignHereEnabled: false,
			isAllSignHereButtonDisabled: false,
			isGenerateForPrintingEnabled: true,
			inPersonSignNowLinks: {},
			signedEmails: [],
			app: null,
			isDocSigned: false,
			urls: null,
			signStatusInterval: null,
			isSignStatusChecking: false,
			isSignStatusRequestInProgress: false,
			isSigned: {
				agent: false,
				customer: false,
				coCustomer: false,
			},
			signees: [
				'customer',
				'coCustomer'
			],
			allSigned: false,
			envelopeId: null,
			customerSignMethod: null,
			coCustomerSignMethod: null,
			hasCoApplicant: null,
			fetchingApp: true,
			isTimeToCheckStatus: false,
			closeTab: false,
			isEmailSentToCustomer: false,
			isCoCustomerSigned: false,
			isQC: false,
			isShowPopupNotice: false,
			intervalId: null
		};
	},
	watch: {
		'isDocSigned': {
			handler(val) {
				if (val) {
					// this.navToUploads();
				}
			}
		},
		'isTimeToCheckStatus': {
			handler(val) {
				if (val) {
					console.log('isTimeToCheckStatus', this.isTimeToCheckStatus);
					this.checkStatus()
				}
			}
		}
	},
	async mounted() {
		this.saveLoading(true);
		this.app = this.application;
		// Don't disable buttons if signNowInvite exists - allow resending
		// Only disable if we're in the middle of an operation
		if (this.app.application.docuseal_submission_method === "embedded") {
			this.parseSubmitters(this.app.application.docuseal_submitters);
			this.isAllSignHereButtonDisabled = true;
		}
		if (this.authUser.isTabletSignAllowed) {
			this.isAllSignHereEnabled = true
			this.isGenerateForPrintingEnabled = false
		}
		this.saveLoading(false);
	},
	beforeUnmount() {
		clearInterval(this.intervalId);
	},
	beforeDestroy() {
		// Stop checking when component is destroyed
		this.stopSignStatusChecking();
	},
	beforeRouteLeave(to, from, next) {
		// Stop checking when navigating away from this page
		this.stopSignStatusChecking();
		next();
	},
	computed: {
		...mapState({
			authUser: state => state.auth.authUser,
		}),
		// Check if e-signature was sent (only for email invite method, not embedded or printing)
		isESignatureSent() {
			return this.app?.application && this.checkSigningMethod('eSignature')
		},
		// Check if contract was generated for printing
		isContractGeneratedForPrinting() {
			return this.app?.application && (this.checkSigningMethod('print') || this.checkSigningMethod('onlyDealer'))
		},
		// Check if embedded signing (ALL SIGN HERE) was initiated
		isEmbeddedSigningInitiated() {
			return this.app?.application && this.checkSigningMethod('embedded')
		},
		// Disable right button if left button (e-signature) was selected
		isRightButtonDisabled() {
			return this.isESignatureSent;
		},
	},
	methods: {
		...mapActions([
			'removeAlerts',
			'saveLoading',
			'showErrorAlert',
			'showInfoAlert',
			'showSuccessAlert',
			'showWarningAlert'
		]),
		async checkSignStatus() {
			// Prevent multiple simultaneous requests
			if (this.isSignStatusRequestInProgress) {
				console.log('Sign status request already in progress, skipping...');
				return;
			}
			this.isSignStatusRequestInProgress = true;
			try {
				let id = this.$route.params.applicationId
				let results = await getSignNowStatusApi({ id })
				console.log("results ==> ", results);
				if (results.docuseal) {
					let finished = true;
					for (const submitter of results.submitters) {
						if (submitter.status !== "completed") {
							finished = false;
							break;
						}
					}
					this.parseSubmitters(results.submitters);
					if (finished) {
						console.log("All signers complete")
						this.app = await this.getApplication();
						this.stopSignStatusChecking();
					}
					return;
				} else if (results) {
					this.signedEmails = results
				} else {
					return
				}
				this.signedEmails = results.map(element => element.replace(' (dev)', '').replace(' (prod)', '').replace(' (staging)', '').toLowerCase());
				console.log('this.signedEmails', this.signedEmails);
				const allEmailsPresent = Object.values(this.inPersonSignNowLinks)
					.map(obj => obj.email) // Extract emails
					.every(email => email && this.signedEmails.includes(email.toLowerCase()));
				console.log("this.signedEmails ==> ", this.signedEmails);
				console.log("this.inPersonSignNowLinks ==> ", this.inPersonSignNowLinks);
				console.log("Object.values(this.inPersonSignNowLinks) ==> ", Object.values(this.inPersonSignNowLinks));
				if (allEmailsPresent) {
					console.log("allEmailsPresent ==> ", allEmailsPresent);
					// Stop checking once all signatures are complete
					this.stopSignStatusChecking();
				}
			} catch (error) {
				console.error('Error checking sign status:', error);
			} finally {
				this.isSignStatusRequestInProgress = false;
			}
		},
		startSignStatusChecking() {
			// Clear any existing interval
			this.stopSignStatusChecking();
			// Set flag to indicate we're checking
			this.isSignStatusChecking = true;
			// Start checking immediately
			this.checkSignStatus();
			// Set up interval to check every 30 seconds
			this.signStatusInterval = setInterval(() => {
				this.checkSignStatus();
			}, 30000); // 30 seconds
			console.log('Started periodic signature status checking');
		},
		stopSignStatusChecking() {
			if (this.signStatusInterval) {
				clearInterval(this.signStatusInterval);
				this.signStatusInterval = null;
				this.isSignStatusChecking = false;
				console.log('Stopped periodic signature status checking');
			}
			// Reset the request flag when stopping
			this.isSignStatusRequestInProgress = false;
		},
		async download(event) {
			this.saveLoading(true);
			let data;
			try {
				data = await downloadPdf({
					id: this.app.application.id,
				});
			} catch (error) {
				this.saveLoading(false);
				console.log('data', data);
				this.showErrorAlert(error);
			}
			let byteCharacters = atob(data.base64);
			let byteNumbers = new Array(byteCharacters.length);
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}
			let byteArray = new Uint8Array(byteNumbers);
			let file = new Blob([byteArray], { type: 'application/pdf;base64' });
			let fileURL = URL.createObjectURL(file);
			let newWin = window.open(fileURL);
			if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
				let errorMsg = this.$i18n.t('sign.popupNotice');
				this.showWarningAlert(errorMsg);
				this.isShowPopupNotice = true;
			}
			this.saveLoading(false);
		},
		async openLink(link) {
			window.open(link, '_blank');
		},
		async sign(method) {
			this.isAllSignHereButtonDisabled = true
			this.removeAlerts();
			let id = this.$route.params.applicationId;
			this.saveLoading(true);
			try {
				// Check if this is a resend for e-signature
				const isResend = this.app.application.signNowSent && method === 'eSignature' && this.isESignatureSent;
				let data;
				const payload = {
					id: id,
					method: method
				}
				if (isResend) {
					// For legacy functionality, new functionality can determine if it's a resend or new invite in one function
					data = await resendSignNowInviteApi(payload);
				} else {
					// For creating submission or resending with new docuseal implementation
					data = await sendEmailInvite(payload);
				}
				console.log("data ==> ", data);
				if (method === 'embedded') {
					// Check if response has an error code (response can be an array or object)
					const errorResponse = Array.isArray(data) ? data[0] : data;
					if (errorResponse && errorResponse.code) {
						// Show error message from response
						const errorMessage = errorResponse.message || 'An error occurred while generating the contract.';
						this.showErrorAlert(errorMessage);
						// Reset button disabled state so user can try again
						this.isAllSignHereButtonDisabled = false;
						this.saveLoading(false);
						return;
					}
					if (this.app.application.signNowSent) {
						this.inPersonSignNowLinks = data;
					} else {
						this.parseSubmitters(data.submitters);
					}
					// Refresh app data to update UI state
					this.app = await this.getApplication();
					// Keep button disabled after successful click - it will be available again after page refresh
					// Don't reset isAllSignHereButtonDisabled here, let it stay true until page refresh
					this.saveLoading(false);
					// Start periodic signature status checking
					this.startSignStatusChecking();
					return
				} else if (method === "print" && !this.app.application?.signNowSent && data.url) {
					await this.openLink(data.url);
				}
				// Handle response - resend API returns different structure
				let result;
				if (isResend) {
					// Resend API returns the result directly
					result = data;
				} else {
					// Regular invite API is expected to return JSON, but axios already deserializes JSON.
					// Only parse when backend returned a raw string.
					result = (typeof data === 'string') ? JSON.parse(data) : data;
				}
				console.log('result', result);
				if (
					result.status
					&& result.status === 'success'
				) {
					// Check if this is a resend before refreshing
					const wasESignatureSent = this.isESignatureSent;
					const wasFirstSend = method === 'eSignature' && !wasESignatureSent;
					// Refresh app data to update UI state
					this.app = await this.getApplication();
					let message = wasESignatureSent && method === 'eSignature'
						? 'The e-signature request has been resent.'
						: 'The invite has been sent.';
					if (method === "eSignature" && result.message) {
						message = result.message;
					}
					if (method === "print") {
						message = "Opening contract in a new tab";
					}
					this.showSuccessAlert(message);
					// Only navigate away if it's the first time sending e-signature
					// For resend or printing, stay on the page
					if (wasFirstSend) {
						this.saveLoading(false);
						return this.$router.replace({
							name: 'BankVerification',
							params: this.$route.params
						});
					}
				} else {
					this.showErrorAlert('Something went wrong.' + JSON.stringify(data));
				}
				console.log('data', data);
			} catch (error) {
				console.log("error ==> ", error);
				// Reset button disabled state on error so user can try again
				if (method === 'embedded') {
					this.isAllSignHereButtonDisabled = false;
				}
				if (error?.response?.data?.errorMessage === 'Unable to find a route to match the URI: document/asd') {
					this.showErrorAlert('signNow template id is wrong.');
				} else {
					this.showErrorAlert('Something went wrong: ' + JSON.stringify(error.response?.data?.errorMessage || error.message));
				}
			}
			this.saveLoading(false);
		},
		parseSubmitters(data) {
			const checkAutoCompleteSubmitter = (submitter) => submitter?.submission_events?.find(item => item.event_type === "api_complete_form");//Checks if the submission was an 'automatic sign' for prepopulating
			const links = [];
			for (const submitter of data ?? []) {
				if (!checkAutoCompleteSubmitter(submitter)) {
					links.push({ ...submitter, isClicked: false });
				}
			}
			this.inPersonSignNowLinks = links.sort(this.sortSubmitters);
		},
		sortSubmitters(a,b) {
			const sortOrder = {
				"Dealer": 0,
				"Applicant": 1,
				"Co-applicant 1": 2,
				"Co-applicant 2": 3,
				"Co-applicant 3": 4,
			}
			return sortOrder[a.role] - sortOrder[b.role];
		},
		checkSigningMethod(method) {
			return (this.app?.application?.docuseal_submission_method ?? this.app?.application?.signNowInvite) === method;
		}
	}
};
</script>

<template>
	<div>
		<!--e-signature-template-->
		<div class="e-signature-template">
			<div class="container-xl">
				<div class="row">
					<div class="col-24">
						<div class="template__page-title">
							<h1>GENERATE CONTRACT</h1>
						</div>
						<div class="template__page-description">
							<p>
								Choose a method for executing the contract.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="mb-5"></div>
			<form @submit.prevent="() => {}" novalidate>
				<div class="container-xl template--vh">
					<div class="row">
						<div class="col-lg-12">
							<div
								:class="'tffi-card tffi-card-main-card e-signature-card ' + ((app?.application && checkSigningMethod('eSignature')) ? 'active' : '')">
								<div class="row">
									<div class="col-lg-12 d-flex align-items-center">
										<p class="my-0" v-if="!isESignatureSent">
											Route the contract to all parties' emails for e-signature
										</p>
										<p class="my-0" v-if="isESignatureSent">
											E-signature request sent. Click here to send it again.
										</p>
									</div>
									<div class="col-lg-12 d-flex align-items-center justify-content-center justify-content-xl-end">
										<button @click="sign('eSignature')" :disabled="isDisableButtons"
										        class="tffi-btn tffi-btn--solid theming primary-color mx-auto-lg w-100 fw-bold">
											<span v-if="!isESignatureSent">ROUTE FOR E-SIGNATURE</span>
											<span v-if="isESignatureSent">RESEND REQUEST</span>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-12">
							<div
								:class="'tffi-card tffi-card-main-card e-signature-card ' + ((app?.application && (checkSigningMethod( 'print') || checkSigningMethod( 'onlyDealer') || checkSigningMethod('embedded'))) ? 'active' : '')">
								<div class="row">
									<div class="col-lg-12 d-flex align-items-center">
										<p class="my-0" v-if="isGenerateForPrintingEnabled && !isContractGeneratedForPrinting && !isEmbeddedSigningInitiated">
											Prepare the contract for signing in person
										</p>
										<p class="my-0" v-if="isGenerateForPrintingEnabled && isContractGeneratedForPrinting">
											Contract previously generated for signing in person.
										</p>
										<p class="my-0" v-if="isAllSignHereEnabled && !isEmbeddedSigningInitiated && Object.keys(inPersonSignNowLinks).length === 0">
											All parties will sign now on this device
										</p>
										<p class="my-0" v-if="isEmbeddedSigningInitiated && Object.keys(inPersonSignNowLinks).length === 0">
											Contract previously generated for signing in person.
										</p>
										<p class="my-0" v-if="Object.keys(inPersonSignNowLinks).length > 0">
											When each party is ready to sign, find and click their button below. Each party will review and
											sign the contract in another browser tab. After they have signed, return to this browser tab.
										</p>
									</div>
									<div class="col-lg-12 d-flex align-items-center justify-content-center justify-content-xl-end">
										<button v-if="isGenerateForPrintingEnabled" @click="sign('print')" :disabled="isRightButtonDisabled"
										        :class="'tffi-btn tffi-btn--solid mx-auto-lg w-100 fw-bold ' + (isRightButtonDisabled ? 'theming secondary-color' : 'theming primary-color')">
											<span v-if="!isContractGeneratedForPrinting || Object.keys(inPersonSignNowLinks).length > 0">GENERATE PDF FOR PRINTING</span>
											<span v-if="isContractGeneratedForPrinting && Object.keys(inPersonSignNowLinks).length === 0">GENERATE CONTRACT AGAIN</span>
										</button>
										<button v-if="isAllSignHereEnabled" @click.prevent="sign('embedded')"
										        :disabled="isAllSignHereButtonDisabled || isRightButtonDisabled"
										        :class="'tffi-btn tffi-btn--solid mx-auto-lg w-100 fw-bold ' + ((isAllSignHereButtonDisabled || isRightButtonDisabled) ? 'theming secondary-color' : 'theming primary-color')">
											<span v-if="!isEmbeddedSigningInitiated || isAllSignHereEnabled">ALL SIGN HERE</span>
										</button>
									</div>
								</div>
								<div v-if="app.application.signNowSent" class="row mt-5" v-for="(item, key) in inPersonSignNowLinks" :key="key"> <!-- Remove element when no longer needed --->
									<div class="col-lg-12 d-flex align-items-center">
										<p class="my-0">
											Click here when {{ item.name }} is ready to sign
										</p>
									</div>
									<div class="col-lg-12 d-flex align-items-center justify-content-center justify-content-xl-end">
										<button v-if="isAllSignHereEnabled" @click="[item.isClicked = true, openLink(item.link)]"
										        :disabled="item.isClicked ?? false"
										        class="tffi-btn tffi-btn--solid theming primary-color mx-auto-lg w-100 fw-bold">
											<span v-if="!item.isClicked">READY TO SIGN</span>
											<span v-if="item.isClicked">
												<span
													v-if="(item.email && signedEmails.includes(item.email.toLowerCase()))">
													<img :src="checkMark" alt="Check Mark" /> SIGNED
												</span>
												<span v-else>SEE OTHER TAB</span>
											</span>
										</button>
									</div>
								</div>
								<div v-if="!app.application.signNowSent" class="row mt-5" v-for="(item, key) in inPersonSignNowLinks" :key="key">
									<div class="col-lg-12 d-flex align-items-center">
										<p class="my-0">
											Click here when {{ item.name }} is ready to sign
										</p>
									</div>
									<div class="col-lg-12 d-flex align-items-center justify-content-center justify-content-xl-end">
										<button v-if="isAllSignHereEnabled" @click="[item.isClicked = true, openLink(`${docusealUrl}/s/${item.slug}`)]"
										        :disabled="(item.isClicked ?? false) || item.status === 'completed'"
										        class="tffi-btn tffi-btn--solid theming primary-color mx-auto-lg w-100 fw-bold">
											<span v-if="!item.isClicked && item.status !== 'completed'">READY TO SIGN</span>
											<span v-if="item.isClicked || item.status === 'completed'">
												<span
													v-if="item.status === 'completed'">
													<img :src="checkMark" alt="Check Mark" /> SIGNED
												</span>
												<span v-else>SEE OTHER TAB</span>
											</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.sign-links {
	list-style: none;
	padding-left: 0px;
}

select {
	display: inline!important;
}

.active {
	border: 2px solid var(--tffi-primary-color);
}
</style>
